import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=322a816f"
import script from "./FilesList.vue?vue&type=script&lang=ts"
export * from "./FilesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports